import { LetterbookSeriesType } from "features/Letterbooks/types";
import LetterbooksBookRow from "../shared/LetterbooksBookRow";
import Text from "hardcover-ui/components/Text";

export default function LetterbookSeriesRow({
  letterbook,
}: {
  letterbook: LetterbookSeriesType;
}) {
  const { bookSeries } = letterbook.data;
  const size =
    bookSeries.position &&
    Math.round(bookSeries.position) === bookSeries.position
      ? "lg"
      : "sm";
  return (
    <div
      className={`flex flex-row space-x-2 max-w-screen py-4 border-b border-secondary`}
    >
      <Text size="xl" className="font-bold pl-1 mr-2 w-12">
        {(bookSeries.position || bookSeries.position === 0) ? (
          <>#{bookSeries.position}</>
        ) : (
          <>{bookSeries.details}</>
        )}
      </Text>
      <LetterbooksBookRow
        book={letterbook.book}
        size={size}
        settings={{
          linkContributions: true,
        }}
      />
    </div>
  );
}
